import { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import Toggles from '@domain/toggles/Toggles'

import { CATALOG_CODES } from '@/constants'
import { getVibiaWebUrl } from '@/components/layout/ProfessionalShell/publicNavUrls'

// Una entrada por locale+catálogo: el menú es el mismo para toda la sesión y el endpoint ya
// cachea en su lado; esto evita repetir la llamada cada vez que se remonta el shell.
const cache = new Map()

/**
 * Menú del sitio público (nav + buscador) ya compuesto, tal cual lo pinta vibia.com (DV-6550).
 *
 * Lo sirve awareness en `/fetch/shell`: no hablamos con el CMS ni recomponemos nada aquí, que es
 * justo lo que haría que los dos menús se desincronizasen. Si falla, devuelve null y la cabecera
 * se queda como estaba.
 */
export default function usePublicShell() {
	const { locale } = useIntl()
	const navigation = useSelector((state) => state.ui.navigation, shallowEqual)
	const catalogCode = CATALOG_CODES[navigation.catalog]
	const [shell, setShell] = useState(null)

	const enabled = Toggles.isEnabled('professionalHeaderPublicNav')

	useEffect(() => {
		if (!enabled || !locale || !catalogCode) return undefined

		const key = `${locale}:${catalogCode}`
		if (cache.has(key)) {
			setShell(cache.get(key))
			return undefined
		}

		let cancelled = false

		fetch(`${getVibiaWebUrl()}/fetch/shell?locale=${locale}&catalog=${catalogCode}`)
			.then((response) => (response.ok ? response.json() : null))
			// El endpoint responde 200 aunque falle (su proxy manda cualquier otro estado al
			// legacy), así que el `error` del cuerpo es la única señal real de fallo.
			.then((data) => (data && !data.error && data.header ? data : null))
			.then((data) => {
				if (cancelled) return
				cache.set(key, data)
				setShell(data)
			})
			.catch(() => {
				if (!cancelled) setShell(null)
			})

		return () => { cancelled = true }
	}, [enabled, locale, catalogCode])

	return shell
}
